import type { Recipe } from '@/types';
import { time } from '@/time';

const recipe: Recipe = {
  title: 'Mac & Cheese',
  source: 'https://www.seriouseats.com/ingredient-stovetop-mac-and-cheese-recipe',
  totalTime: time(0, 15),
  servings: 2,
  tags: { type: 'side' },
  ingredients: [
    { name: 'macaroni', quantity: '6', unit: 'oz' },
    { name: 'water' },
    { name: 'salt' },
    { name: 'evaporated milk', quantity: '6', unit: 'oz' },
    { name: 'cheese', quantity: '6', unit: 'oz',
      note: 'grated (Cheddar, Fontina, Gruyere, Jack, other melting cheeses)',
    },
    { name: 'hot sauce',
      note: 'optional',
    },
    { name: 'mustard',
      note: 'optional',
    },
  ],
  directions: [
    {
      title: 'Boil macaroni',
      bullets: [
        "In medium skillet, place {macaroni} & add just enough cold {water} to cover",
        "Add pinch of {salt}",
        "Bring to boil over high heat, stirring frequently",
        "Cook ~6 min, stirring, until water almost fully absorbed & macaroni just shy of al dente",
      ],
    },
    {
      title: 'Build sauce',
      bullets: [
        "Add {evaporated milk} & bring to boil",
        "Add {cheese}",
        "Reduce heat to low",
        "Cook ~2 min, stirring continuously, until cheese melts & liquid reduces to creamy sauce",
      ],
    },
    {
      title: 'Season',
      bullets: [
        "Season to taste with {salt}, {hot sauce} and/or {mustard}",
      ],
    },
  ],
};

export default recipe;
